import React from "react";
import { Link } from "react-router-dom";

//  $$ Styles $$ \\
import "../../assets/styles/footer/footer.scss";

// Images \\
import logoNew from "../../assets/images/LogoNew.png";
import payme from "../../assets/images/download.png";
import uzum from "../../assets/images/uzum-og.png";
import click from "../../assets/images/click-white.jpg";

// Icons \\
import { FaLinkedinIn } from "react-icons/fa";
import { FaFacebookF } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";

const footer = () => {
  return (
    <div>
      <footer>
        <div className="containers">
          <div className="footer_items">
            <div className="footer_items_content">
              <div className="footer_items_logo w-48">
                <Link to={"/"} className="linkLogo w-full">
                  <img src={logoNew} className="w-full" alt="" />
                </Link>
                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit.</p>
              </div>

              <div className="importantLinks">
                <p>Important Links</p>

                <ul>
                  <li>
                    <Link to={"/"} className="Links">
                      Home
                    </Link>
                  </li>
                  <li>
                    <Link to={"/aboutUs"} className="Links">
                      About Us
                    </Link>
                  </li>
                  <li>
                    <Link to={"/products"} className="Links">
                      Products
                    </Link>
                  </li>
                  <li>
                    <Link to={"/service"} className="Links">
                      Service
                    </Link>
                  </li>
                  <li>
                    <Link to={"/product_colculation"} className="Links">
                      Product Colculation
                    </Link>
                  </li>
                </ul>
              </div>

              <div className="contact">
                <p className="title">Contact Us</p>
                <p>Call: (237) 681-812-255</p>
                <p>Email: fildineesoe@gmail.com</p>
                <p>Address: 0123 Some place</p>
                <p>Some country</p>
              </div>

              <div className="Newsletter">
                <p className="title">Payments</p>

                <div className="icons">
                  <img src={payme} alt="" />
                  <img src={uzum} alt="" />
                  <img src={click} alt="" />
                </div>

                {/* <form>
                  <span className="span">
                    <input
                      type="text"
                      className="emailInput"
                      placeholder="Enter your email address"
                    />
                    <BiLogoTelegram className="tg" />
                  </span>
                </form> */}
              </div>
            </div>

            <hr className="hr" />

            <div className="end">
              <p>© 2023 Sodikjon Nurmirzaev, "Sheyx Mebellar"</p>

              <div className="social">
                <Link href="" target="_blank">
                  <div className="anchor_box">
                    <FaLinkedinIn className="social_icons" />
                  </div>
                </Link>
                <Link href="" target="_blank">
                  <div className="anchor_box">
                    <FaFacebookF className="social_icons" />
                  </div>
                </Link>
                <Link href="" target="_blank">
                  <div className="anchor_box">
                    <FaInstagram className="social_icons" />
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default footer;
